module.exports = __webpack_public_path__ + "static/img/power_on01.da66c46.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/power_on01.gif
// module id = /dmI
// module chunks = 1